import React from 'react'

const ViewPartyDetailsContext = React.createContext()

export default ViewPartyDetailsContext
